<template>
  <div class="doll-content">
    <div class="doll-content-left">
      <el-scrollbar>
        <div class="doll-item">
          <img src="xxx">
          <div class="itme-right">
            <p>asdasda</p>
            <p>dsadsa</p>
            <p class="item-consumption">asdsad</p>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div class="doll-content-right">

    </div>
  </div>
</template>

<script>
import requstsMethod from "common/const";
import { response } from "network/response";
export default {
  data(){
    return{
      infoList:[]
    }
  },
  methods:{
    initData(){
      this.infoDrawer = true;
      response(requstsMethod.fun_Get_Toy_Use_Detail_List,{
        billiardsId: JSON.parse(localStorage.billiardsInfo).billiardsId,
        // deviceId: this.dollList[this.active].deviceId.toString(),
        pageQueryDto:{
          start: 0,
          limit: 1000
        }
      })
      .then(data => {
        console.log(data,'娃娃机使用记录')
        this.infoList = data.dataList.reverse();
      })
    }
  },
  created(){
    this.initData();
  }
}
</script>
<style lang="scss" scoped>
.doll-content{
  display: flex;
  justify-content: space-between;
  height: 100%;
  .doll-content-left{
    height: 100%;
    width: 43.9560%;
    box-shadow: 0px 0px 5px #000;
    ::v-deep.el-scrollbar{
      height: 100%;
      .el-scrollbar__wrap{
        .el-scrollbar__view{
          padding: 8px;
        }
      }
    }
    .doll-item{
      display: flex;
      height: 90px;
      text-align: left;
      color: #fff;
      background: #3e3e3e;
      box-shadow: 0px 0px 5px #000;
      border-radius: 2px;
      margin-bottom: 8px;
      >img{
        float: left;
        height: 80px;
        width: 80px;
        margin-right: 5px;
        margin-left: 4px;
        margin-top: 5px;
      }
      .itme-right{
        float: left;
        width: calc(100% - 88px);
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        >p{
          line-height: 30px;
          height: 30px;
          font-size: 14px;
        }
        .item-consumption{
          color: #ffa970;
        }
      }
    }
  }
  .doll-content-right{
    height: 100%;
    width: 55.0439%;
    box-shadow: 0px 0px 5px #000;
  }
}
</style>